export default class Defer<T> {
  promise: Promise<T>;
  resolve: (value?: T | PromiseLike<T>) => void;
  reject: (reason?: T | PromiseLike<T>) => void;
  then: (...args) => void;
  catch: (...args) => void;
  constructor() {
    const promise = new Promise<T>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
    this.then = (...args) => {
      promise.then.apply(promise, args);
    };
    this.catch = (...args) => {
      promise.catch.apply(promise, args);
    };
    this.promise = promise;
  }
}
